@if (sale.biddingprocedure_id.length > 10) {
<div class="row">
    @if (getArrayElementById(biddingprocedures(), 'biddingprocedure_id', sale.biddingprocedure_id); as biddingprocedure) {
    <div class="col">
        <table class="table">
            <thead>
                <th></th>
                <th>Associated Bidding Procedures Name</th>
                <th>Bidding Procedures Status</th>
            </thead>
            <tbody>
                <tr class="clickable" (click)="isExpanded[sale.biddingprocedure_id] = ! isExpanded[sale.biddingprocedure_id]">
                    <td class="row-toggle"><i-bs [name]="iconNames.ChevronDown" [@openClose]="isExpanded[sale.biddingprocedure_id] ? 'open' : 'closed'" class="d-inline-block"></i-bs></td>
                    <td>
                        {{biddingprocedure.biddingprocedure_name}}
                    </td>
                    <td>
                        {{biddingprocedure.bidding_procedure_status}}
                    </td>
                </tr>
                @if (isExpanded[sale.biddingprocedure_id]) {
                <tr>
                    @if (biddingprocedure.bidding_procedure_touse; as currentBiddingProcedure) {
                    <td colspan="20">
                        <div class="row">
                            @if (currentBiddingProcedure.minimum_overbid && currentBiddingProcedure.minimum_overbid.length) {
                            <div class="col-xl-6 col-xxl-4 my-2 ">
                                <h2 class="column-header">MINIMUM OVERBID/GOOD FAITH DEPOSIT</h2>
                                <table class="table table-borderless definitions w-100">
                                    <tbody>
                                        @for (bid of currentBiddingProcedure.minimum_overbid; track bid) {
                                        <tr>
                                            <td>{{ bid.Type }}:</td>
                                            @if (bid.AmountType === 'Dollar Amount') {
                                            <td class="text-end px-2">{{ bid.DollarAmount | currency }}</td>
                                            }
                                            @else if (bid.AmountType === 'Percentage') {
                                            <td class="text-end px-2">{{ bid.PercentageAmount }}% {{bid.Percentageof}}</td>
                                            }
                                            @else {
                                            <td class="px-2">{{ bid.AmountType}}</td>
                                            }
                                            <td>{{ bid.Notes}}</td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                            }
                        </div>
                        @if (currentBiddingProcedure.bid_protections.length) {
                        <div class="row">
                            <div class="col">
                                <h2 class="column-header">BID PROTECTIONS</h2>
                                <table class="table">
                                    <tbody>
                                        <tr>
                                            <td><strong>Type</strong></td>
                                            <td><strong>Amount</strong></td>
                                            <td><strong>Notes</strong></td>
                                        </tr>
                                        @for (protection of currentBiddingProcedure.bid_protections; track protection) {
                                        <tr>
                                            <td>
                                                {{protection.Type}}
                                            </td>
                                            @if (protection.AmountType === 'Dollar Amount') {
                                            <td>{{ protection.DollarAmount | currency }}</td>
                                            }
                                            @else if (protection.AmountType === 'NA') {
                                            <td>N/A</td>
                                            }
                                            @else if (protection.AmountType === 'Not Required') {
                                            <td>Not Required</td>
                                            }
                                            @else if (protection.AmountType === 'Percentage') {
                                            <td>{{ protection.PercentageAmount }}% {{protection.Percentageof}}</td>
                                            }
                                            <td>{{protection.Notes}}</td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        }
                        <div class="row">
                            @if (currentBiddingProcedure.consulation_parties && currentBiddingProcedure.consulation_parties.length) {
                            <div class="col-xl-6 col-xxl-4 my-2 ">
                                <h2 class="column-header">CONSULTATION PARTIES</h2>
                                <table class="table table-borderless definitions w-100">
                                    <tbody>
                                        @for (party of currentBiddingProcedure.consulation_parties; track party) {
                                        <tr>
                                            <td>&bull; {{ party }}</td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                            }
                            @if (currentBiddingProcedure.consulation_parties_notes && currentBiddingProcedure.consulation_parties_notes.length) {
                            <div class="col-xl-6 col-xxl-4 my-2 ">
                                <h2 class="column-header">CONSULTATION PARTIES NOTES</h2>
                                <div [innerHTML]="currentBiddingProcedure.consulation_parties_notes"></div>
                            </div>
                            }
                        </div>
                        <div class="row">
                            @if (currentBiddingProcedure.credit_bid_parties && currentBiddingProcedure.credit_bid_parties.length) {
                            <div class="col-xl-6 col-xxl-4 my-2 ">
                                <h2 class="column-header">CREDIT BID</h2>
                                <table class="table table-borderless definitions w-100">
                                    <tbody>
                                        <tr>
                                            <td><strong>Right to Credit Bid</strong></td>
                                            <td>{{ currentBiddingProcedure.right_to_credit_bid }}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Credit Bid Parties</strong></td>
                                            <td>
                                                <ul>
                                                    @for (party of currentBiddingProcedure.credit_bid_parties; track party) {
                                                    <li>
                                                        {{ party }}
                                                    </li>
                                                    }
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            }
                            @if (currentBiddingProcedure.credit_bid_description && currentBiddingProcedure.credit_bid_description.length) {
                            <div class="col-xl-6 col-xxl-4 my-2 ">
                                <h2 class="column-header">NOTES</h2>
                                <div [innerHTML]="currentBiddingProcedure.credit_bid_description"></div>
                            </div>
                            }
                        </div>
                        <div class="row">
                            @if (biddingprocedure.timeline && biddingprocedure.timeline.length) {
                            <div class="col-xl-6 col-xxl-4 my-2 ">
                                <h2 class="column-header">TIMELINES</h2>
                                <table class="table table-borderless definitions w-100">
                                    <tbody>
                                        @for (entry of biddingprocedure.timeline; track entry) {
                                        <tr>
                                            <td><strong>{{entry.type}}</strong></td>
                                            <td>{{ entry.date | date }}</td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                            }
                        </div>
                        <div class="row">
                            <court-documents [documents]="biddingprocedure.court_documents" colsDefn="col-12"></court-documents>
                        </div>
                    </td>
                    }
                </tr>
                }
            </tbody>
        </table>
    </div>
    }
</div>
}


@if (sale.bidders_and_bids?.length) {
<div class="row">
    <div class="col">
        <table class="table">
            <thead>
                <th></th>
                <th>Assets</th>
                <th>Bidders</th>
                <th>Initial/Competing Bid</th>
                <th>Bid Type</th>
                <th class="text-end">Total Consideration</th>
            </thead>
            <tbody>
                @for (bandb of sale.bidders_and_bids; track bandb) {

                <tr class="clickable" (click)="isExpanded[bandb.bid_id] = ! isExpanded[bandb.bid_id]" [attr.aria-expanded]="isExpanded[bandb.bid_id]">
                    <td class="row-toggle"><i-bs [name]="iconNames.ChevronDown" [@openClose]="isExpanded[bandb.bid_id] ? 'open' : 'closed'" class="d-inline-block"></i-bs></td>
                    <td>
                        <ul class="comma-list">
                            @for (asset of bandb.bidassets; track asset) {
                            <li>
                                {{asset.asset_name}}
                            </li>
                            }
                        </ul>
                    </td>
                    <td>
                        <ul class="comma-list">
                            @for (bidder of bandb.bidders; track bidder) {
                            <li>
                                @if (bidder.entityType=="person") {
                                    <a href="/people/{{bidder.entity_id}}">{{bidder.entity_name}}</a>
                                }
                                @if (bidder.entityType == "organisation") {
                                    <a href="/organizations/{{bidder.entity_id}}">{{bidder.entity_name}}</a>
                                }
                            </li>
                            }
                        </ul>
                    </td>
                    <td>
                        {{ bandb.bid_initial_competing }}
                    </td>
                    <td>
                        <ul class="comma-list">
                            @if (bandb.bid_stalking_horse) {
                            <li>Stalking Horse</li>
                            }
                            @if (bandb.bid_successful) {
                            <li>Successful</li>
                            }
                            @if (bandb.bid_withdrawn) {
                            <li>Withdrawn</li>
                            }
                            @if (bandb.bid_back_up) {
                            <li>Back-up Bid</li>
                            }
                        </ul>
                    </td>
                    <td class="text-end">
                        @if (bandb.total_consideration_amount_derived > 0) {

                        {{ bandb.total_consideration_amount_derived | currency : bandb.total_consideration_currency }}

                        } @else {

                        N/A

                        }
                    </td>
                </tr>
                @if (isExpanded[bandb.bid_id]) {
                <tr @expandCollapse>
                    <td colspan="20">
                        <div class="collapsible">
                            <div class="row w-100">
                                @if (bandb.bidassets.length) {
                                <div class="col-xl-6 col-xxl-4 my-2">
                                    <h2 class="column-header">ASSETS</h2>
                                    <table class="table table-borderless definitions w-100">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Asest Name</th>
                                                <th>Substantially All Assets?</th>
                                                @if (notSubstantiallyAllAssets(assets)) {
                                                <th>Asset Type</th>
                                                }
                                            </tr>
                                        </thead>

                                        <tbody>
                                            @for (asset of bandb.bidassets; track asset) {

                                            @if (getAsset(assets, asset.asset_id); as assetInfo) {

                                            <tr class="clickable" (click)="isExpanded[asset.asset_id] = ! isExpanded[asset.asset_id]">
                                                <td class="row-toggle"><i-bs [name]="iconNames.ChevronDown" [@openClose]="isExpanded[asset.asset_id] ? 'open' : 'closed'" class="d-inline-block"></i-bs></td>
                                                <td>
                                                    {{ asset.asset_name }}
                                                </td>
                                                <td class="ps-2">
                                                    {{ assetInfo.substantially_all_assets }}
                                                </td>
                                                @if (notSubstantiallyAllAssets(assets)) {
                                                <td class="ps-2">
                                                    @if (assetInfo.asset_type?.length) {

                                                    {{assetInfo.asset_type?.join(',')}}

                                                    }
                                                </td>
                                                }
                                            </tr>
                                            @if (isExpanded[asset.asset_id]) {
                                            <tr @expandCollapse>
                                                <td></td>
                                                <td colspan="5">
                                                    <div class="collapsible w-100">
                                                        <div>
                                                            <div class="row">
                                                                <div class="col">
                                                                    @if (assetInfo.assets_full_description) {

                                                                    <h5>ASSET FULL DESCRIPTION</h5>
                                                                    <div [innerHTML]="assetInfo.assets_full_description"></div>

                                                                    }
                                                                    @if (assetInfo.asset_notes) {

                                                                    <h5>Asset notes</h5>
                                                                    <div [innerHTML]="assetInfo.asset_notes"></div>

                                                                    }
                                                                </div>
                                                                @if (assetInfo.child_asset.length) {
                                                                <div class="col">
                                                                    <h5>Child assets</h5>
                                                                    <ul>
                                                                        @for (child of assetInfo.child_asset; track child) {
                                                                        <li>
                                                                            {{ child.asset_name}}
                                                                        </li>
                                                                        }
                                                                    </ul>
                                                                </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            }

                                            }

                                            }
                                        </tbody>
                                    </table>
                                </div>
                                }
                                @if (bandb.bid_protections?.length) {
                                <div class="col-xl-6 col-xxl-4 my-2">
                                    <h2 class="column-header">BID PROTECTIONS</h2>
                                    <table class="table">
                                        <tbody>
                                            @for (protection of bandb.bid_protections; track protection) {
                                            <tr>
                                                <td>
                                                    {{protection.TypeString}}
                                                </td>
                                                <td>
                                                    {{protection.value}}
                                                </td>
                                            </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                }
                                @if (bandb.bidder_companies?.length) {
                                <div class="col-xl-6 col-xxl-4 my-2">
                                    <h2 class="column-header">BIDDERS & ASSOCIATED ORGANIZATIONS</h2>
                                    <ul>
                                        @for (bidder of bandb.bidder_companies; track bidder) {
                                        <li>
                                            <a [routerLink]="'/organizations/' + bidder.entity_id" target="_blank">
                                                {{bidder.entity_name}}
                                            </a>
                                        </li>
                                        }
                                    </ul>
                                </div>
                                }
                                @if (bandb.considerations?.length) {
                                <div class="col-xl-6 col-xxl-4 my-2">
                                    <h2 class="column-header">CONSIDERATIONS</h2>
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>Consideration Component</th>
                                                @if (considerationIncludesDebt(bandb.considerations)) {
                                                <th>Debt</th>
                                                }
                                                <th class="text-end">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (consideration of bandb.considerations; track consideration) {
                                            <tr>
                                                <td>
                                                    {{ consideration.consideration_component }}
                                                </td>
                                                @if (considerationIncludesDebt(bandb.considerations)) {
                                                <td>
                                                    @if (consideration.instruments_dips?.length) {

                                                    <ul class="list-inline m-0">
                                                        @for (instrument of consideration.instruments_dips; track instrument) {
                                                        <li class="list-inline-item">
                                                            <a href="#" (click)="gotoInstrument($event, instrument)">{{ instrument.instrument_name}} </a>
                                                        </li>
                                                        }
                                                    </ul>

                                                    }
                                                    @if (consideration.debt_other?.length) {

                                                    {{ consideration.debt_other }}

                                                    }
                                                </td>
                                                }
                                                <td class="text-end">
                                                    {{ consideration.amount | currency: consideration.currency }}
                                                </td>
                                            </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                }
                                @if (bandb.notes.length) {
                                <div class="col-xl-6 col-xxl-4 my-2">
                                    <h2 class="column-header">NOTES</h2>
                                    <div [innerHTML]="bandb.notes"></div>
                                </div>
                                }
                            </div>
                        </div>
                    </td>
                </tr>
                }

                }
            </tbody>
        </table>
    </div>
</div>
}

<div class="row">
    @if (sale.investment_banker_brokers && sale.investment_banker_brokers.length) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">INVESTMENT BANKER/BROKER</h2>
        <table class="table table-borderless definitions w-100">
            <thead></thead>
            <tbody>
                @for (banker of sale.investment_banker_brokers; track banker) {
                <tr>
                    <td>
                        <a href="/organizations/{{banker.entity_id}}" class="mt-1">{{banker.entity_name}}</a>
                    </td>
                </tr>
                }
            </tbody>
        </table>
        @if (sale.marketing_efforts && sale.marketing_efforts.length > 5) {
        <h2 class="column-header">MARKETING EFFORTS</h2>
        <div [innerHTML]="sale.marketing_efforts"></div>
        }
    </div>
    }
    @if (sale.assetsale_timeline && sale.assetsale_timeline.length) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">TIMELINE</h2>
        <table class="table table-borderless definitions w-100">
            @for (timepoint of sale.assetsale_timeline; track timepoint) {

            <tr>
                <td>
                    {{ timepoint.type }}
                    @if (timepoint.description.length > 5) {
                    ({{ timepoint.description | stripTags }})
                    }
                </td>
                <td class="ps-2">{{ timepoint.date_of_timeline_display}}</td>
            </tr>

            }
        </table>
    </div>
    }

    @if (sale.assetsale_notes && sale.assetsale_notes.length > 5) {
    <div class="col-xl-6 col-xxl-4 my-2">
        <h2 class="column-header">SALE NOTES</h2>
        <div [innerHTML]="sale.assetsale_notes"></div>
    </div>
    }
    <court-documents [documents]="sale.court_documents" colsDefn="col-12"></court-documents>
</div>